import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {ISharePointGroupHolder} from "@coso-replicator/core";

@Injectable({
  providedIn: "root"
})
export class GroupsService {
  private getBaseRoute(instanceId: string, connectionId: string | number): string {
    return `/api/configurations/${instanceId}/sharepoint/${connectionId}/user-creation/sharepoint-groups`;
  }
  constructor(private http: HttpClient) {}

  get(instanceId: string, connectionId: string | number): Observable<ISharePointGroupHolder[]> {
    const baseRoute = this.getBaseRoute(instanceId, connectionId);
    return this.http.get<ISharePointGroupHolder[]>(baseRoute);
  }
}
